import { render, staticRenderFns } from "./Upsert.vue?vue&type=template&id=0c383420&"
import script from "./Upsert.vue?vue&type=script&lang=js&"
export * from "./Upsert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports